// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".favorite{display:flex;align-items:center;z-index:2;background:var(--white);border-radius:var(--button-border-radius);padding:var(--space-1) var(--space-3);cursor:pointer}.favorite .text{margin-right:4px;font-size:var(--font-size-14)}.favorite .af{font-size:1.3em}.favorite .af-heart-full{color:var(--coral)}@media (max-width: 969px){.favorite .text{display:none}.favorite.round{border-radius:50%;width:32px;height:32px;justify-content:center;padding:var(--space-1)}}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
